export default __webpack_public_path__ + "static/media/img (3).0f5aca78.jpg";